module.exports = __webpack_public_path__ + "static/img/case-right.917cd93.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/pc/index/smart/case-right.png
// module id = 0AoV
// module chunks = 0 2